import { render, staticRenderFns } from "./ChatSystemAnnouncementsFeed.vue?vue&type=template&id=21165a62&scoped=true"
import script from "./ChatSystemAnnouncementsFeed.vue?vue&type=script&lang=js"
export * from "./ChatSystemAnnouncementsFeed.vue?vue&type=script&lang=js"
import style0 from "./ChatSystemAnnouncementsFeed.vue?vue&type=style&index=0&id=21165a62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21165a62",
  null
  
)

export default component.exports